import createIcon from '../../createIcon';

/**
 * @component @name YoutubeSearchedFor
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuMDEgMTQuMjU5OEgxNi4yMUwxNS45NCAxMy45ODk4QzE2LjkyIDEyLjg0OTggMTcuNTEgMTEuMzc5OCAxNy41MSA5Ljc1OTc3QzE3LjUxIDYuMTY5NzcgMTQuNiAzLjI1OTc3IDExLjAxIDMuMjU5NzdDNy40MiAzLjI1OTc3IDQuNTEgNi4yNTk3NyA0LjUxIDkuNzU5NzdIMkw1Ljg0IDEzLjc1OThMMTAgOS43NTk3N0g2LjUxQzYuNTEgNy4yNTk3NyA4LjUzIDUuMjU5NzcgMTEuMDEgNS4yNTk3N0MxMy40OSA1LjI1OTc3IDE1LjUxIDcuMjY5NzcgMTUuNTEgOS43NTk3N0MxNS41MSAxMi4yMzk4IDEzLjQ5IDE0LjI1OTggMTEuMDEgMTQuMjU5OEMxMC4zNiAxNC4yNTk4IDkuNzUgMTQuMTE5OCA5LjE5IDEzLjg3OThMNy43MSAxNS4zNTk4QzguNjggMTUuOTI5OCA5LjggMTYuMjU5OCAxMS4wMSAxNi4yNTk4QzEyLjYyIDE2LjI1OTggMTQuMDkgMTUuNjY5OCAxNS4yMyAxNC42ODk4TDE1LjUgMTQuOTU5OFYxNS43NDk4TDIwLjUxIDIwLjczOThMMjIgMTkuMjU5OEwxNy4wMSAxNC4yNTk4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const YoutubeSearchedFor = createIcon('YoutubeSearchedFor', [
  [
    'path',
    {
      d: 'M17.01 14.2598H16.21L15.94 13.9898C16.92 12.8498 17.51 11.3798 17.51 9.75977C17.51 6.16977 14.6 3.25977 11.01 3.25977C7.42 3.25977 4.51 6.25977 4.51 9.75977H2L5.84 13.7598L10 9.75977H6.51C6.51 7.25977 8.53 5.25977 11.01 5.25977C13.49 5.25977 15.51 7.26977 15.51 9.75977C15.51 12.2398 13.49 14.2598 11.01 14.2598C10.36 14.2598 9.75 14.1198 9.19 13.8798L7.71 15.3598C8.68 15.9298 9.8 16.2598 11.01 16.2598C12.62 16.2598 14.09 15.6698 15.23 14.6898L15.5 14.9598V15.7498L20.51 20.7398L22 19.2598L17.01 14.2598Z',
      key: 'gdruyt',
    },
  ],
]);

export default YoutubeSearchedFor;
